export default __webpack_public_path__ + "locales/lv/PreparationPortal.json?hash=87ee5a2850edfb86dd44a236f8d0720e";